export const STORYLANE_SCRIPT_SRC = 'https://js.storylane.io/js/v2/storylane.js'

/**
 * Only the demo id is stored server-side, so the embed url is built here — a
 * change to Storylane's url shape is one edit instead of a data migration.
 */
export function storylaneDemoUrl(demoId: string) {
  return `https://app.storylane.io/demo/${demoId}?embed=inline`
}

export const HEARTBEAT_INTERVAL_MS = 30_000

export const NEW_DEMO_DAYS = 30

export const GENERAL_FOLDER_KEY = 'general'
